import axios from "axios";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})

const logOut = () => {
  const user = JSON.parse(localStorage.getItem("userInfo"));
  if (user.role) {
    localStorage.clear();
    window.location.href = '/panel';
  } else { 
    localStorage.clear();
    window.location.href = '/';
  }
}

const isWithinBusinessHours = (from, to) => {
  const now = new Date();

  const currentMinutes = now.getHours() * 60 + now.getMinutes();

  // Maneja "08:00:00" y "15:00:00"
  const [fromHours, fromMinutes] = from.split(':').map(Number);
  const [toHours, toMinutes] = to.split(':').map(Number);

  const fromTotal = fromHours * 60 + fromMinutes;
  const toTotal = toHours * 60 + toMinutes;

  return currentMinutes >= fromTotal && currentMinutes <= toTotal;
};

export {
  logOut,
  Toast,
  isWithinBusinessHours
};
